module.exports = __webpack_public_path__ + "img/Personal_guide.ddbb8bb3.jpg";